import { mapState, mapActions } from 'vuex';

export default {
  name: 'NotificationsWidget',
  data() {
    return {
      dialog: false,
      removableIdsList: [],
      notificationsRequestsIntervalTimer: null,
    };
  },
  computed: {
    ...mapState('locations', ['suffix']),
    ...mapState('notifications', ['notifications']),
  },
  watch: {
    suffix() {
      this.updateNotificationsRequestsIntervalTimer();
    },
  },
  created() {
    this.createNotificationsRequestsIntervalTimer();
    this.getNotifications();
  },
  beforeDestroy() {
    this.clearNotificationsRequestsIntervalTimer();
  },
  methods: {
    ...mapActions('notifications', ['getNotifications', 'deleteNotifications']),
    updateRemovableList(id) {
      if (this.removableIdsList.includes(id)) {
        this.removableIdsList = this.removableIdsList.filter(el => el !== id);
      } else {
        this.removableIdsList.push(id);
      }
    },
    createNotificationsRequestsIntervalTimer() {
      this.notificationsRequestsIntervalTimer = setInterval(
        () => this.getNotifications(),
        10000,
      );
    },
    clearNotificationsRequestsIntervalTimer() {
      clearInterval(this.notificationsRequestsIntervalTimer);
    },
    updateNotificationsRequestsIntervalTimer() {
      this.clearNotificationsRequestsIntervalTimer();
      this.createNotificationsRequestsIntervalTimer();
      this.getNotifications();
    },
    async removeNotifs() {
      const ids = this.removableIdsList.length
        ? this.removableIdsList
        : this.notifications.map(({ id }) => id);
      this.$VBlackerTheme.openLoadingSpinner();
      try {
        await this.deleteNotifications({ ids });
        this.updateNotificationsRequestsIntervalTimer();
        this.removableIdsList = [];
      } catch (e) {
        this.$VBlackerTheme.notification.error(e);
      } finally {
        this.$VBlackerTheme.closeLoadingSpinner();
      }
    },
    closePopup() {
      this.dialog = false;
    },
  },
};
